export class CreateUser {
    email: string;
    password: string;
    confirmPassword: string;
    firstName: string;
    lastName: string;
}
